import React from 'react';
import {
  Dialog, DialogContent, DialogTitle, Divider, IconButton, DialogContentText,
} from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

export default function Modal(props) {
  const {
    // eslint-disable-next-line react/prop-types
    isOpen, handleClose, title, subtitle, children, size, ...other
  } = props;

  return (
    <Dialog
      fullWidth
      maxWidth={size}
      open={isOpen}
      onClose={handleClose}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...other} // Apply additional props here, which can include custom styles
    >
      {title ? (
        <>
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {title}
            <IconButton
              data-testid="close-button"
              onClick={() => handleClose()}
            >
              <CancelOutlinedIcon />
            </IconButton>
          </DialogTitle>
          <Divider />
        </>
      ) : null}
      <DialogContent>
        {subtitle ? (
          <DialogContentText>
            {subtitle}
          </DialogContentText>
        ) : null}
        {children}
      </DialogContent>
    </Dialog>
  );
}
